// The phone "Menu" sheet (all destinations, credits, account links). Opened from
// the tab bar's Menu tab and from the avatar in the header, so its flag is
// shared app state rather than local to either.
export function useMobileMenu() {
	const open = useState<boolean>("mobile-menu-open", () => false);

	function show() {
		open.value = true;
	}

	function close() {
		open.value = false;
	}

	function toggle() {
		open.value = !open.value;
	}

	return { open, show, close, toggle };
}
